import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { ROUTES } from '../constant/constants';
import { AuthContext } from '../context/AuthProvider';

const ClientProtectedRoute = ({ children }) => {
  const { isAuthenticated, accessToken, refreshToken } =
    useContext(AuthContext);
  const location = useLocation();

  // Check if user has valid tokens
  const hasValidTokens = accessToken && refreshToken;

  // If not authenticated and no valid tokens, redirect to login
  if (!isAuthenticated && !hasValidTokens) {
    return (
      <Navigate
        to={ROUTES.LOGIN}
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  // If authenticated or has valid tokens, render the protected component
  return children;
};

export default ClientProtectedRoute;
